// eslint-disable-next-line no-useless-escape
export const PhoneNumberRegex = /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/;

export const LinkedinProfileRegex = /^(http(s)?:\/\/)?([\w]+\.)?linkedin\.com\/(pub|in|profile)\/([-a-zA-Z0-9]+)\/*/gm;

export const LinkHasProtocolRegex = /^(http(s)?:\/\/)/;
